<template>
    <div v-if="isCanAccess">
        <breadcrumb class="px-4 bg-light pb-0" :items="breadcrumbs" />
        <div class="page-content">
            <list />
        </div>
    </div>
</template>

<script>
import Breadcrumb from "@/components/commons/breadcrumb.vue";
import List from "@/module/settings/sms-defaults/list.vue";
import EXTENSIONS from "@/constants/extensions";

export default {
    async mounted() {
        await this._getSetting();
        this.isCanAccess =
            this._isExtensionEnabled(EXTENSIONS.CODE.CODE_SMS) ||
            this._isExtensionEnabled(EXTENSIONS.CODE.CODE_2_WAY_MESSAGING);
        if (!this.isCanAccess) {
            window.location.href = process.env.APPS + "business/business"; // External Redirect
        }
    },
    components: {
        Breadcrumb,
        List
    },
    data() {
        return {
            isCanAccess: false
        };
    },
    computed: {
        breadcrumbs() {
            return [
                {
                    text: "Settings",
                    href: process.env.APPS + "business/business"
                },
                {
                    text: "List of SMS Defaults",
                    href: "#"
                }
            ];
        }
    }
};
</script>
